import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  item: null,
  status: 0, // 0 no status, 1 loading, 2 success, 3 error
  removables: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
